module.exports = __webpack_public_path__ + "static/integration.35318c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/integration.png
// module id = 667
// module chunks = 35783957827783